import React from 'react';

const ManagmentSlider = () => {
  const images = [
    {
  src: require("../../src/assets/images/website/Hospitalmang3-300.webp"),
  srcSmall: require("../../src/assets/images/website/Hospitalmang3-150.webp"),
  title: "Patient",
  description: "The patient portal is designed to manage primary & family members under the same account with a unique ID for each member.",
  link: "/patientmanagment"
},

    {
    src: require("../../src/assets/images/website/doctors10-300.webp"),
    srcSmall: require("../../src/assets/images/website/doctors10-150.webp"),
    title: "Doctor",
    description:
      "A doctor portal is designed based on the physician's specialty and can work for any specialization.",
    link: "/doctormanagment",
  },
    {
  src: require("../../src/assets/images/website/223-300.webp"),
  srcSmall: require("../../src/assets/images/website/223-150.webp"),
  title: "Hospital",
  description: "A hospital portal is designed to manage multi-specialty and different consultation modes.",
  link: "/hospitalmanagment"
},

   {
  src: require("../../src/assets/images/website/pharmacy1-300.webp"),
  srcSmall: require("../../src/assets/images/website/pharmacy1-150.webp"),
  title: "Pharmacy",
  description: "Pharmacy portals simplify medication management, allowing easy prescription refills and secure communication with pharmacists.",
  link: "/pharmacymanagment"
},
  ];

  return (
    <>
      <hr className='m-0' style={{ background: '#D3F2FF' }} />
      <div className='management-slider py-5'>
        <div className='container-90'>
          <div className='row m-0 align-items-stretch justify-content-center'>
            <div className='col-12'>
              <div className='scroll-container'>
                <div className='row m-0 align-items-stretch justify-content-start'>
                  {images.map((image, index) => (
                    <div key={index} className='col-lg-3 col-md-6 col-sm-6 col-12'> 
                      <div className='management-card'>
                        <div className='management-img-section'>
                          <img
  src={image.srcSmall}
  srcSet={`
    ${image.srcSmall} 150w,
    ${image.src} 300w
  `}
  sizes="(max-width: 768px) 150px, 300px"
  className="w-100"
  alt="Doctors reviewing patient data on a digital healthcare platform"
  loading="lazy"
  decoding="async"
/>

                          <p className='management-title' style={{ 
                            color: 'white', 
                            // textShadow: '1px 1px 3px rgba(255, 255, 255, 0.8)', 
                            // backgroundColor: 'rgba(255, 255, 255, 0.7)', 
                            padding: '10px 15px', 
                            borderRadius: '5px', 
                            margin: '0', 
                            fontSize: '1.5rem', 
                            fontWeight: '600', 
                            textAlign: 'center' 
                          }}>
                            {image.title}
                          </p>
                        </div>
                        <div className='management-doctor-content'>
                          <p style={{ color: '#555', fontSize: '0.9rem' }}>{image.description}</p>
                          <a href={image.link} style={{ textDecoration: 'none' }}>
                            <img src={require("../../src/assets/images/website/blackarrow.png")} className='management-icons' alt="Arrow" />
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManagmentSlider;